import template from './time_logged_reject.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class TimeLoggedRejectViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.rejection_reason = ko.observable();
	};

	close()
	{
		this.dialog.close();
	};

	async save_reject()
	{
		// Validate
		if (this.rejection_reason() == '' || this.rejection_reason() == undefined || this.rejection_reason() ==  null)
		{
			Grape.alerts.alert({type: 'error', message: tr('Please give a valid reason for rejecting'), title: tr('Error', 'Error')});
			return;
		}

		let data = {
			employee_id: Utils.current_employee_id(),
			task_time_id: this.dialog.bindings.task_time_id,
			rejection_reason: this.rejection_reason()
		};

		let res = await Grape.fetches.postJSON('/time_management/reject_time_logged_entry', data);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully rejected time log request.'), title: tr('Success', 'Success')});
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};
};

class TimeLoggedRejectPage
{
	constructor (bindings)
	{
		this.viewModel = new TimeLoggedRejectViewModel(this);
		this.bindings = bindings;
		this.task_time_id = bindings.task_time_id;
		$('#reject_dialog').on('keypress', (e) => {
			let code = (e.keyCode ? e.keyCode : e.which);

			if(code == 13) //Enter keycode
				document.getElementById("btn_accept").click();
		});
	};
};

export default {
	name: 'TimeLoggedReject',
	dialog_class: TimeLoggedRejectPage,
	template: template,
	template_filename: 'translation/dialogs/time_logged_reject',
	provider: 'ps'
};
